import { Button, Container, Form, Modal } from "react-bootstrap"
import DataTable from "react-data-table-component"
import { IoHomeOutline } from "react-icons/io5"
import { FaPlus } from "react-icons/fa6"
import { useState } from "react"
import { useEffect } from "react"
import { AiFillDelete, AiTwotoneEdit } from "react-icons/ai"
import Swal from "sweetalert2"
import { CreateClass,GetAllClass,UpdateClassById,DeleteClassById,GetClassById,ClassAvailableByName} from "../../utils/proxy/HospitalClassMasterProxy"
import { Op_per } from "../../utils/Permissions"
import Select from "react-select"
import LoadingComponent from "../Includes/LoadingComponent"

const HospitalClassMaster = () => {
   const [data, setData] = useState([]);
     const [id, setId] = useState();
     const [name, setName] = useState();
     const [description, setDescription] = useState();
     const [reload, SetReload] = useState(false);
     const [show, setShow] = useState(false);
     const [available, setAvailable] = useState(true);
     const [operation, setOperation] = useState('Add');
     const [loading, setLoading] = useState(true);
 
     useEffect(() => {
         const getall = async () => {
             let d = await GetAllClass();
             if (d) {
                 setData(d);
             } else {
                 alert('Error', 'Issues while fetching data')
             }
         }
         getall()
         SetReload(false);
     }, [reload])
 
     useEffect(() => {
         let debounceTimeout;
       
         if (name !== "" && name !== null && name !== undefined) {
           debounceTimeout = setTimeout(async () => {
             // Make API call with name
             const a = await ClassAvailableByName(name);
             setAvailable(a);
           }, 500); // Adjust debounce delay as needed
         }else{
             setAvailable(true);
         }
       
         // Clear timeout when name changes or becomes empty
         return () => clearTimeout(debounceTimeout);
       }, [name]);
 
     const handleShow = () => {
         setShow(true);
     }
 
     const handledelete = async (id) => {
         let d = await DeleteClassById(id);
         if (d.status === 'success') {
             SetReload(true);
             Swal.fire({
                 title: "Success!",
                 text: "Class Deleted !!",
                 icon: "success",
                 confirmButtonText: "OK",
             });
         }
     }
 
     const handleEditShow = (row) => {
         setShow(true);
         setOperation('Edit')
         setId(row.id);
         setName(row.name);
         setDescription(row.desc);
     }
 
     const handleClose = () => {
         setShow(false)
         setAvailable(true);
         setId(null);
         setName(null);
         setDescription(null);
         setOperation('Add')
     }
 
     const handleNameChange = (e) => {
         const { value } = e.target
         setName(value)
     }
 
     const handleSave = async () => {
         if (name == null || name == '') {
             Swal.fire({
                 title: "Warning!",
                 text: "Enter Class Name !!",
                 icon: "warning",
                 confirmButtonText: "OK",
             });
         } else {
             setLoading(false)
             let d = await CreateClass(name, description);
             if (d && d.status === 'success') {
                 setShow(false);
                 SetReload(true);
                 setName(null);
                 setDescription(null);
                 setLoading(true)
                 Swal.fire({
                     title: "Success!",
                     text: "New Class Added !!",
                     icon: "success",
                     confirmButtonText: "OK",
                 });
             } else if (d.status === 'error') {
                 setLoading(true)
                 Swal.fire({
                     title: "Warning!",
                     text: d.message,
                     icon: "warning",
                     confirmButtonText: "OK",
                 });
             } else{
                 setLoading(true)
                 Swal.fire({
                     title: "Warning!",
                     text: "Something Went Wrong!",
                     icon: "warning",
                     confirmButtonText: "OK",
                 });
             }
         }
     }
 
     const handleEditSave = async () => {
         if (name == null || name == '') {
             Swal.fire({
                 title: "Warning!",
                 text: "Enter Class Name !!",
                 icon: "warning",
                 confirmButtonText: "OK",
             });
         } else {
             setLoading(false)
             let d = await UpdateClassById(id, name, description);
             if (d && d.status === 'success') {
                 setShow(false);
                 setOperation('Add')
                 SetReload(true);
                 setId(null);
                 setName(null);
                 setDescription(null);
                 setLoading(true)
                 Swal.fire({
                     title: "Success!",
                     text: "Class Edited !!",
                     icon: "success",
                     confirmButtonText: "OK",
                 });
             } else{
                 setLoading(true)
                 Swal.fire({
                     title: "Warning!",
                     text: "Something Went Wrong!",
                     icon: "warning",
                     confirmButtonText: "OK",
                 });
             }
         }
     }
 
     const columns = [
         // {
         //     name: "Id",
         //     selector: (row) => row.id,
         //   
         
         // },
         {
             name: "Class Name",
             selector: (row) => <div style={{ whiteSpace: 'normal', backgroundColor: row.name === "" || row.name === null ? "#f36e6f" : "", borderRadius: "10px", border: row.name === "" || row.name === null ? "2px solid transparent" : "2px solid transparent", padding: "3px", display: "flex", flexDirection: "row", color: row.name === "" || row.name === null ? "#fff" : "#000", margin: "3px", }}>{row.name ? row.name : "N/A"}</div>,
 
             //width: "20%",
 
             fontSize: 10,
             fontWeight: 'bold',
         },
         {
             name: "Description",
             selector: (row) => <div style={{ whiteSpace: 'normal', backgroundColor: row.desc === "" || row.desc === null ? "#f36e6f" : "", borderRadius: "10px", border: row.desc === "" || row.desc === null ? "2px solid transparent" : "2px solid transparent", padding: "3px", display: "flex", flexDirection: "row", color: row.desc === "" || row.desc === null ? "#fff" : "#000", margin: "3px", }}>{row.desc ? row.desc : "N/A"}</div>,
 
             //width: "15%",
 
             fontSize: 10,
             fontWeight: 'bold',
         },
     ];
 
     const CustomHeader = ({ children }) => (<div style={{ backgroundColor: 'blue', padding: '10px', color: 'white' }}>    {children}  </div>);
 
     if (Op_per.get().MASTERS_HOSPITALCLASSMASTER.ALLOW_DELETE || Op_per.get().MASTERS_HOSPITALCLASSMASTER.ALLOW_EDIT) {
         columns.push({
             name: "Actions",
             selector: (row) => (
                 <div key={row.id}>
                     <AiFillDelete
                         onClick={() => handledelete(row.id)}
                         style={{ color: "#f36e6f", fontSize: 20, display: Op_per.get().MASTERS_HOSPITALCLASSMASTER.ALLOW_DELETE ? '' : 'none' }}
                     />
                     &nbsp;&nbsp;&nbsp;
                     <AiTwotoneEdit
                         onClick={() => handleEditShow(row)}
                         style={{ color: "#9889e6", fontSize: 20, display: Op_per.get().MASTERS_HOSPITALCLASSMASTER.ALLOW_EDIT ? '' : 'none' }}
                     />
                 </div>
             ),
         })
     }
 
     return (
         <Container fluid style={{ minHeight: "80vh" }}>
             <div
                 className="glass-body"
                 style={{
                     margin: 10,
                     display: "flex",
                     flexDirection: "row",
                     justifyContent: "space-between",
                     padding: 0,
                     backgroundColor: 'transparent'
                 }}
             >
 
                 <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                     <ul id="breadcrumb">
                         <li><a href="/"><IoHomeOutline
                             style={{ color: "white", fontSize: 20 }}
                             
                         /></a></li>
                         <li><a href="/class-master"><span class="icon icon-beaker"> </span>Masters</a></li>
                         <li><a href="/class-master"><span class="icon icon-beaker"> </span>Hospital Class Master</a></li>
                         {/* <li><a href="#"><span class="icon icon-double-angle-right"></span>Doctor</a></li> */}
 
                     </ul>
 
                 </div>
             </div>
 
             <div className="glass-body" style={{ margin: 10 }}>
                 <div
                     style={{
                         display: "flex",
                         flexDirection: "row",
                         justifyContent: "space-between",
                     }}
                     className="flex-column-mobile"
                 >
                     <div>
                         <Form.Control
                             className="glass"
                             placeholder="Search"
                             type="text"
                             style={{ display: 'none' }}
                         //   value={searchQuery}
                         //   onChange={(e) => setSearchQuery(e.target.value)}
                         />
                     </div>
                     <div>
                         {Op_per.get().MASTERS_HOLIDAYTYPES.ALLOW_ADD ? (
                             <Button style={{ backgroundColor: "#2194f0" }} onClick={handleShow}>
                                 <FaPlus />
                             </Button>
                         ) : ("")}
                     </div>
                 </div>
                 <div style={{ marginTop: 10 }}>
                     <DataTable
                         columns={columns}
                         data={data}
                         // progressPending={pending}
                         // selectableRows
                         // onSelectedRowsChange={({ selectedRows }) =>
                         // setSelectedRows(selectedRows)
                         //   }
                         pagination
                         customStyles={{ headRow: { style: { backgroundColor: '#c0dfff', padding: 7 }, } }}
                         CustomHeader={<CustomHeader />}
                         // actions={actionsMemo}
                         style={{ marginTop: 10 }}
                         // progressPending={pending}
                         // progressComponent={<LoadingComponent/>}
                         dense
                     />
                 </div>
             </div>
 
             <Modal show={show} onHide={handleClose}>
                 <Modal.Header closeButton>
                     <Modal.Title>{operation} Hospital Class Master</Modal.Title>
                 </Modal.Header>
                 {loading ? <Modal.Body>
                     <Form>
                         <Form.Group className="mb-3" controlId="formBasicPassword">
                             <Form.Label>Class Name <span style={{ color: "red" }} >*</span></Form.Label>
                             <Form.Control
                                 style={{
                                     height: 40,
 
                                     borderColor: available ? '#28B3D2' : 'red',
                                     borderWidth: 1,
                                     paddingHorizontal: 8,
                                     marginBottom: 16,
                                     
                                     borderRadius:10,
                                 }}
                                 type="text"
                                 value={name}
                                 onChange={handleNameChange}
                                 placeholder="Enter Class Name"
                                 required
                             />
                         </Form.Group>
                         <Form.Label>Description </Form.Label>
                         <Form.Control
                             style={{
                                 height: 40,
 
                                 borderColor: '#ccc',
                                 borderWidth: 1,
                                 paddingHorizontal: 8,
                                 marginBottom: 16,
                                 
                                 borderRadius:10,
                             }}
                             type="text"
                             value={description}
                             onChange={(e) => setDescription(e.target.value)}
                             placeholder="Enter Description"
                         />
                     </Form>
                 </Modal.Body> : <div style={{display:'grid',placeContent:'center'}}><LoadingComponent /></div>}
                 <Modal.Footer>
                     <Button variant="secondary" onClick={handleClose}>
                         Close
                     </Button>
                     <Button
                         variant="primary"
                         onClick={operation == 'Add' ? handleSave : handleEditSave}
                     >
                         {operation}
                     </Button>
                 </Modal.Footer>
             </Modal>
 
         </Container>
     )
}

export default HospitalClassMaster
